import React from "react";

import { NavLink } from "react-router-dom";

const Breadcrumb = ({ product }) => {
  return (
    <>
      <nav className="breadcrumb">
        <NavLink to="/">Home </NavLink> <i className="fas fa-angle-right"></i>
        <NavLink to="/products">All Products </NavLink>
        <i className="fas fa-angle-right"></i>
        <NavLink to={`/products?category=${product?.category}`}>{product?.category}</NavLink>
        <i className="fas fa-angle-right"></i>
        <NavLink
          to={`/products?category=${product?.category} & sup_category=${product?.sup_category}`} 
        >{product?.sup_category}
        </NavLink>
        <i className="fas fa-angle-right"></i>
        {product?.name}
      </nav>
    </>
  );
};

export default Breadcrumb;
